<script setup lang="ts">
import type { IProps } from './AddToCalendarButton.types'
import { useAddToCalendar } from '@/domains/investor/event-calendar/composables/useAddToCalendar'

const { event } = defineProps<IProps>()

const { addToCalendar } = useAddToCalendar()
</script>

<template>
  <button
    type="button"
    class="addToCalendarButton"
    @click="addToCalendar(event)"
  >
    {{ $t('investor.eventCalendar.addToCalendar') }}
  </button>
</template>

<style lang="scss" scoped>
.addToCalendarButton {
  @include body-3-medium;
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0;
  color: $text-400;
  white-space: nowrap;
  background: none;
  border: none;
  cursor: pointer;

  &::after {
    content: '';
    width: 1.6rem;
    height: 1.6rem;
    background-image: url('/icons/icn_calendar.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  &:hover {
    text-decoration: underline;
  }
}
</style>
